'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type PrimaryButtonProps = {
  text: string;
  /* 
handler function that will be executed after action
*/
  actionHandler: () => void;
  disabled?: boolean;
  disabledText?: string;
};

export const PrimaryButton = ({
  text,
  actionHandler,
  disabled,
  disabledText,
}: PrimaryButtonProps) => (
  <Button
    className="w-full lg:w-auto"
    size="large"
    color="primary"
    disabled={disabled}
    aria-label={disabled && disabledText ? disabledText : text}
    onClick={actionHandler}
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault(); // To prevent scrolling, when card is clicked.
        actionHandler();
      }
    }}
  >
    {/* 
    this is needed to avoid layout shift when the text in the button is changing (e.g. at validiation)
   */}
    {disabledText ? (
      <span className="flex h-2.5 flex-col overflow-hidden leading-2.5">
        <span>{disabled ? disabledText : text}</span>
        <span className="opacity-0">{disabled ? text : disabledText}</span>
      </span>
    ) : (
      text
    )}
  </Button>
);
